import { Grid, useTheme } from "@mui/material";
import { PageContainer } from "core";
import React from "react";
import { useTranslation } from "react-i18next";
import { SubmitContent, SubmitIdea } from "sections";
//---------------------------------------------------------

export default function Submit({ title }) {
  const { t: home } = useTranslation('home')
  const theme = useTheme();
  return (
    <PageContainer title={title}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SubmitIdea theme={theme} />
        </Grid>
        <Grid item xs={12}>
          <SubmitContent theme={theme} title={`${home('suggest_a_post')}`} />
        </Grid>
      </Grid>
    </PageContainer>
  );
}
